import styled from 'styled-components';
import { HideScrollbarCSS } from 'styles/common';

const TasksGoalsContainer = styled.div`
  background-color: #ffffff;
  width: 100%;
  overflow-y: scroll;
  height: 100%;
  ${HideScrollbarCSS};
`;

export default TasksGoalsContainer;
